import React, { useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import './index.sass'
import { ThemeSwitcher } from '../Button'
import { DarkModeContext } from '../../../global/Theme';

import DesktopNotification from '../../common/DesktopNotification'


export default function DesktopNav() {
    const { isDark } = useContext(DarkModeContext);
    const history = useHistory()
    const dispatch = useDispatch()

    const navState = useSelector(state => state.navbarState)
	let location = useLocation();

    
	const handleNavigationUpdates = () => {
		switch (location.pathname) {
			case "/home":
				dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: true,
                        search: false,
                        post: false,
                        chat: false,
                        profile: false
                    }
                })
				break;
			case "/search":
				dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: false,
                        search: true,
                        post: false,
                        chat: false,
                        profile: false
                    }
                })
				break;
			case "/new-post":
				dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: false,
                        search: false,
                        post: true,
                        chat: false,
                        profile: false
                    }
                })
				break;
			case "/message":
				dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: false,
                        search: false,
                        post: false,
                        chat: true,
                        profile: false
                    }
                })
				break;
			case "/login":
				dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: false,
                        search: false,
                        post: false,
                        chat: false,
                        profile: false
                    }
                })
				break;
			case "/profile":
				dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: false,
                        search: false,
                        post: false,
                        chat: false,
                        profile: true
                    }
                })
				break;
			default:
				dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: false,
                        search: false,
                        post: false,
                        chat: false,
                        profile: false
                    }
                })
		}
    }
    
    useEffect(() => {
        handleNavigationUpdates()
    }, [])

    const onIconClick = (e) => {
        switch (e) {
            case 0:
                history.push('/home')
                dispatch({
                    type: 'UPDATE_NAV', payload: {
                        notification: false,
                        home: true,
                        search: false,
                        post: false,
                        chat: false,
                        profile: false
                    }
                })
                break
            case 1:
                history.push('/search')
                dispatch({ type: 'UPDATE_NAV', payload: {
                    notification: false,
                    home: false,
                    search: true,
                    post: false,
                    chat: false,
                    profile: false
                } })

                break
            case 2:
                history.push('/new-post')
                dispatch({ type: 'UPDATE_NAV', payload: {
                    notification: false,
                    home: false,
                    search: false,
                    post: true,
                    chat: false,
                    profile: false
                } })

                break
            case 3:
                history.push('/message')
                dispatch({ type: 'UPDATE_NAV', payload: {
                    notification: false,
                    home: false,
                    search: false,
                    post: false,
                    chat: true,
                    profile: false
                } })

                break
            case 4:
                history.push('/profile')
                dispatch({ type: 'UPDATE_NAV', payload: {
                    notification: false,
                    home: false,
                    search: false,
                    post: false,
                    chat: false,
                    profile: true
                } })

                break
            case 5:
                history.push('/notification')
                dispatch({ type: 'UPDATE_NAV', payload: {
                    notification: true,
                    home: false,
                    search: false,
                    post: false,
                    chat: false,
                    profile: false
                } })

                break;
        }

        //handleClick(e)
    }

    const handleLogoClick = () => {
        if (location.pathname !== '/home') {
            history.push('/home')
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });

        }
    }

    const notification = useSelector(state=>state.notification)

    return (
        <div id="desktopWrapper" className={isDark ? 'desktopWrapperDark' : 'desktopWapperLight'}>
            <div id="desktopNav" className={isDark ? 'desktopNavDark' : null}>
            {notification.isEnabled && <DesktopNotification text={notification.text} icon={notification.icon}/> }

                <div id="desktopNavLeft">
                    <ThemeSwitcher />
                    <img onClick={handleLogoClick} id="logo" src={require('../../../assets/icons/logo.svg')} />
                </div>
                <div id="desktopNavRight">
                    <img onClick={() => onIconClick(0)} src={navState.home ? require('../../../assets/icons/home_a.svg') : require('../../../assets/icons/home.svg')} />
                    <img onClick={() => onIconClick(1)} src={navState.search ? require('../../../assets/icons/compass_a.svg') : require('../../../assets/icons/compass.svg')} />
                    <img onClick={() => onIconClick(2)} src={navState.post  ? require('../../../assets/icons/plus_a.svg') : require('../../../assets/icons/plus.svg')} />
                    <img onClick={() => onIconClick(3)} src={navState.chat? require('../../../assets/icons/msg_a.svg') : require('../../../assets/icons/msg.svg')} />
                    <img onClick={() => onIconClick(4)} src={navState.profile  ? require('../../../assets/icons/profile_a.svg') : require('../../../assets/icons/profile.svg')} />
                    <img onClick={() => onIconClick(5)} src={navState.notification ? require('../../../assets/icons/notifications_a.svg') : require('../../../assets/icons/notifications.svg')} />
                </div>
            </div>
        </div>
    )
}
